module.exports = __webpack_public_path__ + "img/nav-1.7ecb4fc8.png";